/** Qual arte ilustra o cartão — os desenhos moram em
 * `componentes/ilustracoes-bento.tsx`, um por recurso. */
export type ArteBento = 'trava' | 'consolida' | 'concorda' | 'fundamento';

export type Recurso = {
  titulo: string;
  texto: string;
  arte: ArteBento;
};

// Copy adaptada de apps/site/landing-antiga.html (passos "Como funciona" e
// tabela "defeito por defeito"). O ícone de 20px deu lugar à ARTE grande —
// pedido do dono depois das referências Open Pro/Stellar.
export const RECURSOS: readonly Recurso[] = [
  {
    arte: 'trava',
    titulo: 'Cadastro que trava o que não fecha',
    texto:
      'CPF inválido, soma de quotas diferente do capital, SLU com dois sócios, data impossível — o sistema recusa na hora do cadastro, não no laudo da Junta três semanas depois.',
  },
  {
    arte: 'consolida',
    titulo: 'Consolidação automática',
    texto:
      'O texto consolidado não é redigitado por ninguém: é o contrato inteiro reimpresso a partir do estado atual da sociedade. Por construção, não tem como divergir do preâmbulo.',
  },
  {
    arte: 'concorda',
    titulo: 'Concordância e valor por extenso',
    texto:
      'Gênero, número e valor por extenso saem da mesma função que gera o algarismo — os dois nunca divergem.',
  },
  {
    arte: 'fundamento',
    titulo: 'Fundamento legal em cada cláusula',
    texto:
      'Cada cláusula carrega a norma que a fundamenta e a data em que ela caiu, para não citar instrução normativa revogada.',
  },
] as const;
